export default "__VITE_ASSET__LBLKzltD__"